import './info.panel.scss';

const InfoPanel = ({ children, action = false, color = 'default', className = '' }) => {

  return (

    <section 

      onClick = { () => { action && action() }}
      className = { `flex column items-center text-center infopanel infopanel--${ color } ${ className }`}
  
    >

      { children }

    </section>

  );

};

export default InfoPanel;